import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgTracking = function SvgTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.5C10.067 6.5 8.5 8.06701 8.5 10C8.5 11.933 10.067 13.5 12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.06701 13.933 6.5 12 6.5ZM10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C7.58173 2 4 5.58173 4 10C4 12.4952 5.11171 14.8173 6.4274 16.7017C7.74899 18.5945 9.32655 20.1173 10.3713 21.0297C11.3115 21.8509 12.6885 21.8509 13.6287 21.0297C14.6735 20.1173 16.251 18.5945 17.5726 16.7017C18.8883 14.8173 20 12.4952 20 10C20 5.58173 16.4183 2 12 2ZM5.5 10C5.5 6.41015 8.41015 3.5 12 3.5C15.5899 3.5 18.5 6.41015 18.5 10C18.5 12.0595 17.5744 14.079 16.3427 15.843C15.117 17.5985 13.6372 19.0308 12.6421 19.8999C12.2671 20.2274 11.733 20.2275 11.358 19.8999C10.3628 19.0308 8.88302 17.5985 7.65728 15.843C6.42565 14.079 5.5 12.0595 5.5 10Z"
  })));
};

export { SvgTracking as ReactComponent };
//# sourceMappingURL=tracking.svg.js.map
